export enum TenantImageNameEnum {
  flightLoadingMobileImage = "flightLoadingMobileImage",
  mobileBackground = "mobileBackground",
  bannerPremierDestination = "bannerPremierDestination",
  bannerEnhanceBurn = "bannerEnhanceBurn",
  bannerCashback = "bannerCashback",
  hsbcLogoWhite = "hsbcLogoWhite",
  partnershipLogoWhite = "partnershipLogoWhite",
  partnershipLogoBlack = "partnershipLogoBlack",
  premierMastercard = "premierMastercard",
  premierDestinationJapan = "premierDestinationJapan",
  premierDestinationChina = "premierDestinationChina",
  premierDestinationAustralia = "premierDestinationAustralia",
  premierDestinationItaly = "premierDestinationItaly",
  premierDestinationFrance = "premierDestinationFrance",
  premierDestinationUsa = "premierDestinationUsa",
  premierDestinationKorea = "premierDestinationKorea",
  premierDestinationThailand = "premierDestinationThailand",
  premierDestinationBannerPopup = "premierDestinationBannerPopup",
}
